"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DashboardModule = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * DasboardSection component is used to wrap the content of the dashboard modules.
 */
const DashboardModule = ({
  children,
  className,
  isIntro,
  testId
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    className: className,
    "data-testid": testId ?? getTestId(_constants.DASHBOARD_MODULE),
    isIntro: isIntro,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Inner, {
      children: children
    })
  });
};
exports.DashboardModule = DashboardModule;
